import { html, LitElement } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { customElement, property } from 'lit/decorators.js';
import { commonStyles } from '@styles/common';
import { clearButton } from '@styles/clearButton';
import { inputMaterial } from '@styles/inputMaterial';
import { labelMaterial } from '@styles/labelMaterial';

@customElement('what-field-component')
export class WhatField extends LitElement {

  static styles = [
    commonStyles,
    clearButton,
    inputMaterial,
    labelMaterial,
  ]

  @property()
  placeholder?: string;

  @property()
  labelText?: string;

  @property()
  additionalClasses = "";

  @property()
  currentValue = "";

  @property()
  disabled?: boolean;

  render() {
    return html`
    <input
      type="text"
      name="what"
      class="jr-input-material ${this.additionalClasses}"
      placeholder=${this.placeholder}
      .value=${this.currentValue}
      ?disabled=${ifDefined(this.disabled)}
      @input=${this.inputHandler}
    />
    <button
    type="button"
    class="clear-button"
    @click=${this.clickHandler}
    />
    <label
      class="proposal-form__label"
    >
    ${this.labelText}
    </label>
    `
  }

  private dispatchLocationChangeEvent() {
    const event = new CustomEvent('what-change-event', {
      detail: {
        value: this.currentValue
      }
    });

    this.dispatchEvent(event);
  }

  private inputHandler(event: Event) {
    const { value } = (<HTMLInputElement>event.target);
    this.currentValue = value;

    this.dispatchLocationChangeEvent();
  }

  private clickHandler() {
    this.currentValue = "";

    this.dispatchLocationChangeEvent();
  }
}